module.exports = __webpack_public_path__ + "static/media/Messages.cd63d5d5.svg";